export default __webpack_public_path__ + "static/media/greaterThan.c1a70e85.svg";